import keyMirror from 'keymirror';

export const gameExplanationActionTypes = keyMirror({
	SET_GAME_EXPLANATION_MODAL: null,
});
